export enum TunnelProtocolEnum {
    SSH = 0,
    HTTP = 1,
    HTTPS = 2,
    UltraVNC = 3,
    CService = 4,
    CaosDB = 5,
    Custom = 6,
}

export function TunnelProtocolEnumToString(protocol: TunnelProtocolEnum): string {
    switch (protocol) {
        case TunnelProtocolEnum.SSH:
            return "SSH";
        case TunnelProtocolEnum.HTTP:
            return "HTTP";
        case TunnelProtocolEnum.HTTPS:
            return "HTTPS";
        case TunnelProtocolEnum.UltraVNC:
            return "UltraVNC";
        case TunnelProtocolEnum.CService:
            return "C-Service";
        case TunnelProtocolEnum.CaosDB:
            return "phpMyAdmin";
        case TunnelProtocolEnum.Custom:
            return this.$t("common.custom");
    }
}

export function TunnelProtocolEnumToProtocolName(protocol: TunnelProtocolEnum): string {
    switch (protocol) {
        case TunnelProtocolEnum.SSH:
            return "SSH";
        case TunnelProtocolEnum.HTTP:
            return "HTTP";
        case TunnelProtocolEnum.HTTPS:
            return "HTTPS";
        case TunnelProtocolEnum.UltraVNC:
            return "VNC";
        case TunnelProtocolEnum.CService:
            return "C-Service";
        case TunnelProtocolEnum.CaosDB:
            return "HTTP";
        case TunnelProtocolEnum.Custom:
            return this.$t("common.custom");
    }
}

export function TunnelProtocolToPort(protocol: TunnelProtocolEnum): number {
    switch (protocol) {
        case TunnelProtocolEnum.SSH:
            return 22;
        case TunnelProtocolEnum.HTTP:
            return 80;
        case TunnelProtocolEnum.HTTPS:
            return 443;
        case TunnelProtocolEnum.UltraVNC:
            return 5900;
        case TunnelProtocolEnum.CService:
            return -112;
        case TunnelProtocolEnum.CaosDB:
            return 8080;
    }
}
